__turbopack_context__.v({
  "linkIcon": "CollectionSocials-module__CtaZba__linkIcon",
  "root": "CollectionSocials-module__CtaZba__root",
});
